import { render, staticRenderFns } from "./FormCadastroVaga.vue?vue&type=template&id=b074a9e8&scoped=true"
import script from "./FormCadastroVaga.vue?vue&type=script&lang=js"
export * from "./FormCadastroVaga.vue?vue&type=script&lang=js"
import style0 from "./FormCadastroVaga.vue?vue&type=style&index=0&id=b074a9e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b074a9e8",
  null
  
)

export default component.exports